import Highcharts from "highcharts";
import { MAP_CHART } from "src/config/charts/mapChartConfig";
import mapData from "@highcharts/map-collection/countries/us/us-all.geo.json";

type ChartDataProps = {
  State: string;
  Cases: number;
};

const wrapperFunction = (value: ChartDataProps[]) => {
  const dataArray: Array<[string, number]> = [];

  // Map of specific codes for U.S. territories
  const territoryMap: { [key: string]: string[] } = {
    "us-pr": ["pr-3614"],
    "us-gu": ["gu-3605"],
    "us-as": ["as-6515", "as-6514"],
    "us-mp": ["mp-ti", "mp-sa", "mp-ro"],
    "us-vi": ["vi-3617", "vi-6398", "vi-6399"],
  };

  value?.forEach((item) => {
    const stateCode = item?.State?.toLowerCase();
    const prefixedCode = "us-" + stateCode;

    // Check if the state is in the territoryMap
    if (territoryMap[prefixedCode]) {
      // Add all associated codes for the territory
      territoryMap[prefixedCode]?.forEach((code) => {
        dataArray.push([code, item?.Cases ?? 0]);
      });
    } else {
      // For regular states
      dataArray.push([prefixedCode, item?.Cases ?? 0]);
    }
  });

  return dataArray;
};

export function renderMap(
  data: unknown,
  spec: unknown,
  title: string,
): Highcharts.Options {
  const safeData = Array.isArray(data) ? (data as ChartDataProps[]) : [];
  const max = safeData.reduce((currentMax, item) => {
    const value = Number(item?.Cases ?? 0);
    return Number.isFinite(value) && value > currentMax ? value : currentMax;
  }, 1);
  const colorMax = Math.ceil(max / 10) * 10;

  const mapOptions: Highcharts.Options = {
    ...MAP_CHART,
    // title: { ...MAP_CHART.title, text: title },
    series: [
      {
        type: "map",
        name: "Case Volume",
        mapData,
        color: "#beb697",
        dataLabels: {
          enabled: false,
          format: "{point.name}",
        },
        tooltip: { pointFormat: "Cases: {point.value}" },
        data: wrapperFunction(safeData),
      },
    ],
    colorAxis: {
      min: 0,
      max: colorMax,
      minColor: "#EEEEFF",
      maxColor: "#000022",
      stops: [
        [0, "#EFEFFF"],
        [0.5, "#4444FF"],
        [1, "#000022"],
      ],
    },
  };

  return mapOptions;
}
